/* Widerruf-Hinweis + Pflicht-Checkbox für personalisierte Artikel (§ 312g Abs. 2 Nr. 1 BGB).
   Erscheint nur, wenn der Warenkorb einen individualisierten Artikel enthält (teeinblue: _customization_id). */
(function () {
  var CB_ID = 'WiderrufPersoCheck';
  var MSG = 'Bitte bestätige, dass für individuell gestaltete Artikel kein Widerrufsrecht besteht.';

  function hasPerso(items) {
    return (items || []).some(function (it) {
      var p = it.properties || {};
      if (p._customization_id || p._customization_image) return true;
      return Object.keys(p).some(function (k) { return k.indexOf('_customization') === 0; });
    });
  }

  function buildBox() {
    var w = document.createElement('div');
    w.setAttribute('data-widerruf-perso', '');
    w.style.cssText = 'margin:12px 0;width:100%;box-sizing:border-box;padding:12px 14px;border:1px solid #E1E2E8;border-radius:10px;background:#FAFAFB;font-size:13px;line-height:1.5;color:#3A3B47';
    w.innerHTML = '<label style="display:flex;gap:10px;align-items:flex-start;cursor:pointer;margin:0">' +
      '<input type="checkbox" id="' + CB_ID + '" style="margin-top:3px;flex:0 0 auto;width:18px;height:18px;accent-color:#FF5860">' +
      '<span>Verstanden: Für personalisierte Artikel besteht <strong>kein Widerrufsrecht</strong> (§ 312g Abs. 2 Nr. 1 BGB). <a href="/pages/widerruf" style="color:#FF5860;text-decoration:underline;text-underline-offset:2px">Details</a></span>' +
      '</label>';
    return w;
  }

  function wire(cb, buttons) {
    if (!cb) return;
    try { cb.setCustomValidity(cb.checked ? '' : MSG); } catch (e) {}
    if (!cb.__wBound) {
      cb.__wBound = true;
      cb.addEventListener('change', function () { try { cb.setCustomValidity(cb.checked ? '' : MSG); } catch (e) {} });
    }
    buttons.forEach(function (btn) {
      if (btn.__wPerso) return; btn.__wPerso = true;
      btn.addEventListener('click', function (e) {
        if (!cb.checked) { e.preventDefault(); e.stopPropagation(); try { cb.reportValidity(); } catch (x) {} cb.focus(); }
      }, true);
    });
  }

  function inject(root) {
    if (!root) return;
    var btns = [].slice.call(root.querySelectorAll('.checkout-button, button[name="checkout"]'));
    if (!btns.length) return;
    var existing = root.querySelector('#' + CB_ID);
    if (existing) { wire(existing, btns); return; }
    var anchor = btns[0].closest('.proceed-to-checkout') || btns[0].parentNode;
    var box = buildBox();
    anchor.parentNode.insertBefore(box, anchor);
    wire(box.querySelector('#' + CB_ID), btns);
  }

  function run() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || !hasPerso(cart.items)) {
          document.querySelectorAll('[data-widerruf-perso]').forEach(function (el) { el.remove(); });
          return;
        }
        inject(document.getElementById('Cart'));
        inject(document.getElementById('Cart-Drawer') || document.querySelector('.cart-drawer'));
      })
      .catch(function () {});
  }

  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  var root = document.documentElement;
  root.addEventListener('cart:refresh', function () { setTimeout(run, 200); });
  root.addEventListener('cart-drawer:open', function () { setTimeout(run, 150); });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('a[href$="/cart"], .cart-link, [data-cart-open], .header-cart')) setTimeout(run, 600);
  });
  setTimeout(run, 1400);
})();
